





















import Vue from "vue";
import { Component } from "vue-property-decorator";
@Component({})
export default class Confirm extends Vue {
  data() {
    return {
      confirmDialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        color: "primary",
        width: 290,
        zIndex: 200
      }
    };
  }

  agree() {
    //@ts-ignore
    this.resolve(true);
    //@ts-ignore
    this.confirmDialog = false;
  }

  cancel() {
    //@ts-ignore
    this.resolve(false);
    //@ts-ignore
    this.confirmDialog = false;
  }

  open(title, message, options) {
    //@ts-ignore
    this.confirmDialog = true;
    //@ts-ignore
    this.title = title;
    //@ts-ignore
    this.message = message;
    //@ts-ignore
    this.options = Object.assign(this.options, options);
    return new Promise((resolve, reject) => {
      //@ts-ignore
      this.resolve = resolve;
      //@ts-ignore
      this.reject = reject;
    });
  }
}
